import { render, staticRenderFns } from "./CompetitionDetailRow.vue?vue&type=template&id=488f1078&scoped=true"
import script from "./CompetitionDetailRow.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailRow.vue?vue&type=script&lang=js"
import style0 from "./CompetitionDetailRow.vue?vue&type=style&index=0&id=488f1078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f1078",
  null
  
)

export default component.exports